import { SIGNUP_INVITED } from '../Types';
import createUser from './createUser';

/**
 * Signup an invited user
 */
export const signUpInvited = (signUpDetails) => {
  return (dispatch, getState) => {
    const action = {
      type: SIGNUP_INVITED,
      request: async (apiClient) => {
        const { invitedUser } = getState();
        //create user
        await createUser(apiClient, signUpDetails);

        /** redirect user */
        return invitedUser && redirect(invitedUser.url);
      },
      payload: signUpDetails,
    };

    dispatch(action);
  };
};

const redirect = (redirectUrl) => {
  window.location = redirectUrl;
};

export default signUpInvited;
